import React from "react";
import { DataCard } from "./DataCard";
import { GppBadOutlined, ThumbDownAltOutlined } from "@mui/icons-material";
import { SatisfactionCharts } from "../../charts/tabulation/registros_publicos/SatisfactionCharts";
import { RecomendationCharts } from "../../charts/tabulation/registros_publicos/RecomendationCharts";
import html2canvas from 'html2canvas-pro';
import { saveAs } from 'file-saver';
import { CustomButton } from "../../CustomButton";

export const Tabulation = ({ data: { titulo, fecha, satisfaccion, recomendacion, pqrs }}) => {

    const screenshot = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        html2canvas(document.querySelector("#capture")).then(canvas => {
            ctx.drawImage(canvas, 0, 0);
            const imgURL = canvas.toDataURL('image/png');
            saveAs(imgURL, 'captura.png')
        });
    }

	return (
        <>
            <div style={{ height: 'auto', position: 'relative' }} id='capture'>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '10px 0px 10px 0px' }}>
                    <h3>{ titulo }</h3>
                    <span style={{ fontSize: 11, fontWeight: 600 }}>{ fecha }</span>
                </div>
                
                <div style={{ height: '90%', overflowY: 'auto', scrollbarWidth: 'none', padding: 10 }}>
                    { satisfaccion?.total > 0 && <SatisfactionCharts data={ satisfaccion } /> }
                    { recomendacion?.total > 0 && <RecomendationCharts data={ recomendacion } /> }

                    <div style={{ display: 'flex', gap: 5, margin: '10px 0px 10px 0px' }}>
                        <DataCard
                            icon={ <ThumbDownAltOutlined fontSize="small" htmlColor="#212529" /> }
                            title="Quejas" 
                            value={ pqrs?.queja }
                            background="#E9EBED"
                            color="#212529"
                        />
                        <DataCard 
                            icon={ <GppBadOutlined htmlColor="#212529" /> }
                            title="Reclamos" 
                            value={ pqrs?.reclamo }
                            background="#E9EBED"
                            color="#212529"
                        />
                    </div>
                </div>
            </div>

            <div style={{ position: 'sticky', bottom: 0, background: '#fff', display: 'flex', justifyContent: 'flex-end', padding: 10 }}>
                <CustomButton  
                    name='Descargar'
                    action={ screenshot }
                />
            </div>
        </>
    );
}